module.exports = __webpack_public_path__ + "44fd05e4ebb12f5c15dd338d21520a18.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/images/navigators/ic-anchor-subscription.svg
// module id = 1492
// module chunks = 3